module.exports = __webpack_public_path__ + "static/cases-4-f642a79a64f7e4e6f79fffdaae0cae62.png";